export default {
  strict: true,
  namespaced: true,
  state: {
    sharedAllowedTime: {
      start: '',
      end: ''
    },
    optinAllowedTime: {
      start: '',
      end: ''
    },
    adminTimeBuffer: '',
    serviceData: {
      Shared: {
        id: 1,
        label: ''
      },
      Opoli: {
        id: 2,
        label: ''
      },
      Black: {
        id: 3,
        label: ''
      },
      SUV: {
        id: 4,
        label: ''
      },
      'Private Shuttle': {
        id: 5,
        label: ''
      }
    },
    charterMaxDura: 480,
    charterMinDuration: 0,
    charterMnDurationServiceId: []
  },
  mutations: {
    setSharedAllowedTime (state, value) { state.sharedAllowedTime = value },
    setAdminTimeBuffer (state, value) { state.adminTimeBuffer = value },
    setServiceData (state, value) { state.serviceData = value },
    setSettings (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/settings.js